var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ellipse',{attrs:{"cx":"12","cy":"12","rx":"4.888","ry":"3.088","fill":"none","stroke":"#000","stroke-width":".5"}})}
var staticRenderFns = []

export { render, staticRenderFns }